<template>
    <kgr-profile-part
        v-if="!isEmpty"
        :heading="$t('Kontaktdaten')"
    >
        <template #content>
            <table class="kgr-table">
                <tr
                    v-if="addressIsDefined"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'Adresse'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        <kgr-member-address :member="memberShortProfile" />
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.company"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.company'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.company }}
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.phone"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.phone'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.phone }}
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.phoneBusiness"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.phoneBusiness'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.phoneBusiness }}
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.phoneMobile"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.phoneMobile'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.phoneMobile }}
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.phoneMobileBusiness"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.phoneMobileBusiness'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.phoneMobileBusiness }}
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.emergencyContact"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.emergencyContact'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ memberShortProfile.emergencyContact }}
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.email"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.email'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        <a
                            :href="'mailto:'+memberShortProfile.email"
                            class="kgr-link"
                        >
                            {{ memberShortProfile.email }}
                        </a>
                    </td>
                </tr>

                <tr
                    v-if="memberShortProfile.emailBusiness"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td
                        v-t="'member.emailBusiness'"
                        class="kgr-table__cell"
                    ></td>
                    <td class="kgr-table__cell">
                        <a
                            :href="'mailto:'+memberShortProfile.emailBusiness"
                            class="kgr-link"
                        >
                            {{ memberShortProfile.emailBusiness }}
                        </a>
                    </td>
                </tr>
            </table>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberAddress from '../MemberAddress';
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-part-contact',
    components: {
        'kgr-member-address': MemberAddress,
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        addressIsDefined() {
            return this.memberShortProfile.street && (this.memberShortProfile.zip || this.memberShortProfile.city);
        },
        isEmpty() {
            return !this.addressIsDefined
                    && !this.memberShortProfile.phone
                    && !this.memberShortProfile.phoneMobile
                    && !this.memberShortProfile.email;
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
